import querystring from 'querystring'

const request = function request(url, options = {}) {
  return window.fetch(url, options)
    .then(res => {
      if (res.status !== 204) {
        return res.json().then(body => [res, body])
      }
      return Promise.resolve([res, null])
    })
    .then(([res, body]) => {
      if (res.status === 208) {
        window.location.href = body.redirect
        return new Promise()
      }
      if (res.status >= 200 && res.status < 300) {
        return Promise.resolve(body)
      }
      if (res.status >= 300 && res.status < 400) {
        return Promise.resolve(body)
      }
      return Promise.reject(body)
    })
}

class Api {
  constructor(host, port) {
    this.host = `${host}${port ? `:${port}` : ''}`
  }

  hostname(hostname) {
    return this.get(`/hostnames/${hostname}`)
  }

  cellar(id, lang) {
    return this.get(`/cellars/${id}`, { lang })
  }

  cellarPaymentData(id) {
    return this.get(`/cellars/${id}/payment-data`)
  }

  event(id, lang, places = 1, extras = {}, uiLanguage) {
    const params = { lang, places, uiLanguage }
    for (const [key, value] of Object.entries(extras)) {
      params[`extra_${key}`] = value
    }
    return this.get(`/models/${id}`, params)
  }

  getReservation(id, phone, email) {
    return this.get(`/reservations/${id}`, { phone, email })
  }

  getReservationUuid(id) {
    return this.get(`/reservations/${id}/finalize`)
  }

  finalizeReservation(id, data) {
    return this.post(`/reservations/${id}/finalize`, data)
  }

  removeReservation(id, phone, email) {
    return this.delete(`/reservations/${id}`, { phone, email })
  }

  validateCoupon(coupon, model) {
    return this.post(`/models/${model}/validateCoupon`, { coupon_code: coupon })
  }

  authentication(id, step, data) {
    return this.post(`/auth/${id}/${step}`, data)
  }

  reservation(id, data) {
    return this.post(`/models/${id}/reservation`, data)
  }

  getGiftCard(id, giftCardId, lang) {
    return this.get(`/cellars/${id}/gift-cards/${giftCardId}`, { lang })
  }

  buyGiftCard(id, giftCardId, data) {
    return this.post(`/cellars/${id}/gift-cards/${giftCardId}`, data)
  }

  post(path, payload, headers = {}) {
    const url = `${this.host}${path}`
    return request(
      url,
      {
        method: 'post',
        headers: Object.assign({}, {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }, headers),
        body: JSON.stringify(payload),
      }
    )
  }

  get(path, query = {}) {
    const queryString = querystring.stringify(query)
    const url = `${this.host}${path}?${queryString}`

    return request(url)
  }

  delete(path, query = {}) {
    const queryString = querystring.stringify(query)
    const url = `${this.host}${path}?${queryString}`

    return request(
      url,
      {
        method: 'delete',
      })
  }
}

const apiUrl = process.env.API_URL || `//${window.location.hostname}` // eslint-disable-line
const port = process.env.TEST_PORT || null
const API = new Api(apiUrl, port)
console.log(port)

export default API
